import { useState } from "react";
import { adminApiService } from "../../../utils/api";
import { GfStoreDto } from "@swagger/typescript-fetch-goflyer";

export interface GooglePlaceResult {
  place_id: string;
  name: string;
  geometry: {
    location: { lat: number; lng: number };
  };
  formatted_address: string;
  [key: string]: any;
}

export function useStoreSearch() {
  const [results, setResults] = useState<
    Array<{ source: "api" | "google"; data: GfStoreDto | GooglePlaceResult }>
  >([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const searchStores = async (
    query: string,
    googleSearchFn: (q: string) => Promise<GooglePlaceResult[]>
  ) => {
    setLoading(true);
    setError(null);
    try {
      const apiRes = await adminApiService.gfStoreAdminControllerSearch(
        query,
        1,
        5
      );
      if (apiRes?.data?.length) {
        setResults(
          apiRes.data.map((store) => ({
            source: "api" as const,
            data: store as GfStoreDto,
          }))
        );
      } else {
        // fallback to Google
        const googleResults = await googleSearchFn(query);
        setResults(googleResults.map((g) => ({ source: "google", data: g })));
      }
    } catch (e: any) {
      setError(e?.message || "Unknown error");
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  return { results, loading, error, searchStores };
}
